import { render, staticRenderFns } from "./ReceivedGiftsSummary.vue?vue&type=template&id=6a57c808&scoped=true"
import script from "./ReceivedGiftsSummary.vue?vue&type=script&lang=ts"
export * from "./ReceivedGiftsSummary.vue?vue&type=script&lang=ts"
import style0 from "./ReceivedGiftsSummary.vue?vue&type=style&index=0&id=6a57c808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57c808",
  null
  
)

export default component.exports